<template>
  <v-card variant="outlined" height="100%">
    <v-card-title>Внешние системы</v-card-title>
    <v-list lines="two">
      <v-list-item
        v-for="link in links"
        :key="link.href"
        :href="link.href"
        :title="link.title"
        :subtitle="link.subtitle"
        :prepend-icon="link.icon"
        append-icon="mdi-open-in-new"
        target="_blank"
        rel="noopener noreferrer"
      />
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'ExternalSystemsSection',
  props: {
    wwwroot: {
      type: String,
      required: true,
    },
  },
  computed: {
    links() {
      return [
        {
          title: 'Экспорт в 1С',
          subtitle: 'Передача данных в 1С',
          icon: 'mdi-numeric-1-box-outline',
          href: `${this.wwwroot}/blocks/manage_groups/1c/index.php`,
        },
        {
          title: 'Экспорт вновь поступивших',
          subtitle: 'Бюджет, СКБ Контур, АМБА',
          icon: 'mdi-account-arrow-right-outline',
          href: `${this.wwwroot}/blocks/manage_groups/personal/export.php?xls=3`,
        },
        {
          title: 'Экспорт вновь поступивших',
          subtitle: 'SondaLab',
          icon: 'mdi-account-arrow-right-outline',
          href: `${this.wwwroot}/blocks/manage_groups/personal/export.php?xls=4`,
        },
        {
          title: 'Сетевой город. Образование',
          subtitle: 'Экспорт данных для внешней системы',
          icon: 'mdi-city-variant-outline',
          href: `${this.wwwroot}/blocks/manage_groups/personal/export_city.php`,
        },
      ];
    },
  },
};
</script>
